export default __webpack_public_path__ + "static/media/vin_no_text.581f0c06.png";